import { useCallback, useState, useMemo } from 'react';
import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';
import {
  getDateAddedChoiceOptions,
  CSMLTimeFrame,
} from '../../../model';
import {
  civilDateRangeEqual,
  civilDateRangeToDebugString,
} from '../../../utils';

const yesterday = getCivilDateToday().plus({ days: -1 });
const DEFAULT_RANGE = { start: yesterday, end: yesterday };

export const useDateAddedState = ({
  logger,
  i18n,
  ianaTimeZone,
  handleUsage,
}) => {
  const [dateAddedFilter, setDateAddedFilter] = useState(CSMLTimeFrame.Anytime);
  // date range user selected for 'Custom'
  const [dateAddedFilterCustomDateRange, setDateAddedFilterCustomDateRange] = useState(DEFAULT_RANGE);

  const dateAddedChoiceOptions = useMemo(
    () => getDateAddedChoiceOptions(i18n, ianaTimeZone),
    [i18n, ianaTimeZone]
  );

  const onDateAddedFilterChange = useCallback(({ timeframe: tf, customDateRange: cdr }) => {
    if (tf !== dateAddedFilter) {
      logger.logTrace('onDateAddedFilterChange', { dateAddedFilter: tf });
      setDateAddedFilter(tf);
      if (handleUsage) {
        handleUsage();
      }
    }
    if (!civilDateRangeEqual(cdr, dateAddedFilterCustomDateRange)) {
      logger.logTrace('onDateAddedFilterChange', { customDateRange: civilDateRangeToDebugString(cdr) });
      setDateAddedFilterCustomDateRange(cdr);
      if (handleUsage) {
        handleUsage();
      }
    }
  }, [dateAddedFilter, dateAddedFilterCustomDateRange, handleUsage, logger]);

  return {
    dateAddedChoiceOptions,
    dateAddedFilter,
    dateAddedFilterCustomDateRange,
    onDateAddedFilterChange,
  };
};
